var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-page',[_c('base-bloc',{staticClass:"flex-shrink-0 mb-3",style:(_vm.styleLeftBarLg)},[_c('collaborateur-liste')],1),_c('div',{staticClass:"flex-grow-1 mb-3"},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }